import React, { useEffect } from "react";

function TawkToWidget({ user }) {
  useEffect(() => {
    // Initialize Tawk_API
    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();

    // Configure to prevent auto-popup
    window.Tawk_API.onLoad = function() {
      window.Tawk_API.minimize();
    };

    // Load script only once
    if (!document.getElementById("tawkto-script")) {
      const script = document.createElement("script");
      script.async = true;
      script.src = "https://embed.tawk.to/67fc33790a9c3f190ed48e2c/1iooii5a0";
      script.charset = "UTF-8";
      script.setAttribute("crossorigin", "*");
      script.id = "tawkto-script";
      document.body.appendChild(script);
    }

    return () => {
      const script = document.getElementById("tawkto-script");
      if (script && script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  // Set user attributes when user changes
  useEffect(() => {
    if (window.Tawk_API && user && user.email) {
      setTimeout(() => {
        if (window.Tawk_API.setAttributes) {
          window.Tawk_API.setAttributes({
            email: user.email,
            name: user.displayName || user.email
          });
        }
      }, 500);
    }
  }, [user]);

  // Add CSS to significantly reduce chat widget size
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      /* Target the specific chat button */
      .tawk-button.tawk-button-circle.tawk-button-large {
        width: 40px !important;
        height: 40px !important;
        transform: scale(0.6) !important;
      }
      
      /* Target the SVG icon inside */
      .tawk-min-chat-icon {
        width: 10px !important;
        height: 10px !important;
      }
      
      /* Reduce the container */
      .tawk-min-container {
        transform: scale(0.6) !important;
        transform-origin: bottom right !important;
      }
      
      /* Reduce chat panel size when opened */
      .tawk-chat-panel {
        width: 300px !important;
        height: 400px !important;
      }
      
      /* Mobile adjustments */
      @media (max-width: 768px) {
        .tawk-button.tawk-button-circle.tawk-button-large {
          transform: scale(0.5) !important;
        }
        
        .tawk-min-container {
          transform: scale(0.5) !important;
        }
        
        .tawk-chat-panel {
          width: 260px !important;
          height: 350px !important;
        }
      }
    `;
    document.head.appendChild(style);

    return () => {
      if (style.parentNode) {
        style.parentNode.removeChild(style);
      }
    };
  }, []);

  return null;
}

export default TawkToWidget;